export const FINWISE_PRIVACY_NOTICE_URL =
  'https://storage.googleapis.com/finwise_privacy_2026/FinWise%20Bank%20Privacy%20Notice%20_%2001-2026%20%20%2002.04.2026.pdf';
